<template>
  <div class="lessee-location-dialog">
    <custom-dialog :visible="visible"  width="80%"  :title="model.title" v-on="$listeners">
      <div class="dialog-body">
        <el-row style="padding-bottom: 10px">
          <el-col :span="6">{{ $t('crm_lessee_location_dialog.ji_tuan_ming_cheng') }}：{{ model.data.partnerName }}</el-col>
          <el-col :span="10" :offset="1">{{ $t('crm_lessee_location_dialog.ji_tuan_di_zhi') }}：{{ model.data.address }}</el-col>
        </el-row>
        <div class="table-box">
          <el-row :gutter="50">
            <el-col>
              <div class="search-hd">
                <el-form :inline="true" @submit.native.prevent>
                  <div class="title" style="float: left">
                    <div class="tag centerY"></div>
                    <span>{{ $t('crm_lessee_location_dialog.dglzlfxm') }}</span>
                  </div>
                  <!-- 搜索项 -->
                  <el-form-item style="float: right; margin-right: 0">
                    <el-input :placeholder="$t('crm_lessee_location_dialog.xiang_mu_ming_cheng')" v-model="formSearch.locationName" clearable @keyup.enter.native="onPageChange({ page: 1 })" style="width: 280px">
                      <template slot="append">
                        <div @click="onPageChange({ page: 1 })">
                          <i class="icon icon-search"></i>
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-form>
              </div>
              <custom-table
                ref="tb2"
                border
                type="checkbox"
                v-model="selectedLocationData"
                :size="allTableSize"
                tableCode="rent_location"
                :data="locationList"
                height="500px"
                @selection-change="selectionChange"
                @sort-change="sortChange"
                @filter-change="filterChange"
                :filterArr="['orgName','operator']"
              >
              </custom-table>
            </el-col>
          </el-row>
        </div>
        <div class="table-page">
          <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveLessee">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          title: '',
        };
      },
    },
  },
  data() {
    return {
      visible: false,
      // 右边表格
      locationList: [],
      selectedLocationData: [],
      formSearch: {
        search: '',
        pageSize: 20,
        pageNum: 1,
        bizId: '',
        bizType: 1,
        orgType: 'CS',
        orgName: '',
        locationName: '',
        isAss: 0
      },
      totalRows: 0,
    };
  },

  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.formSearch = JSON.parse(this.resetFormSearch);
      // this.dialogData.partnerId = this.partnerId;
      this.formSearch.bizId = this.model.data.partnerOrgId;
      if (this.model.type === 'rent') {
        this.formSearch.parentId = this.model.largeCustomerId;
      }
      this.getTableList();
    },

    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 获取关联列表
    getTableList: function () {
      this.$getJSON(apis.bizLocationPage, this.formSearch).then((res) => {
        this.locationList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 保存关联
    saveLessee: function () {
      const partnerOrgId = this.model.data.partnerOrgId;
      const partnerId = this.model.data.partnerId;

      // 使用 map 方法整理数组
      const newSelectedLocationData = this.selectedLocationData.map(item => ({
        orgId: partnerId, // 设定 orgId 为 partnerOrgId
        bizId: this.model.type === 'rent' ? this.model.largeCustomerId : partnerOrgId, // 设定 orgId 为 partnerOrgId
        toBizId: item.locationId, // 将 bizId 设置为 item 的 locationId
        bizType: 1, // 添加 bizType 为 1
        toBizType: 4, // 添加 toBizType 为 4
      }));
      this.$postJSON(apis.deviceBindAutomaticBatchSave, newSelectedLocationData).then(() => {
        this.$message({
          message: this.$t('crm_lessee_location_dialog.guan_lian_cheng_gong'),
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    // // 切换页
    // onCurrentPage: function (page) {
    //   this.formSearch.pageNum = page;
    //   this.getLesseePage();
    // },
    // // 切换每页数量
    // onSizeChange: function (size) {
    //   this.formSearch.pageSize = size;
    //   this.getLesseePage();
    // },
  },
};
</script>

<style lang="scss">
.lessee-location-dialog {
  .table-box {
    .title {
      line-height: 24px;
      font-size: 16px;
      padding-left: 10px;
      position: relative;
      color: #595959;
      margin-bottom: 10px;
      .tag {
        width: 4px;
        height: 15px;
        background-color: #00afff;
        left: 0;
      }
    }
  }
}
</style>
